import { deletePet } from "../../api/petService";

export const useDeletePet = (successCallback) => {
    const remove = async (id) => {
        try {
            await deletePet(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete pet:", error);
            throw error;
        }
    };

    return { remove };
};